module.exports = "/_next/static/images/epn_3-8faf27acccd5ec956d2ced36f31a2e94.jpeg";